module.exports = __webpack_public_path__ + "img/right_1.4ebb5bcb.jpg";